import { jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import { useBreakpoint, Breakpoint } from "./hooks/useBreakpoint.js";
import { useHover } from "./hooks/useHover.js";
import { palette } from "./theme/palette.js";
import { mergeRefs } from "./utils/refs.js";
import { I as Icon } from "./Icon.js";
import X from "./components/Icons/X.js";
import styles from "./components/Close/styles.module.scss";
const Close = React.forwardRef(function ButtonForwardedRef(props, ref) {
  const { small, testId, ariaLabel = "Lukk", onClick, className, color = palette.blueberry600 } = props;
  const breakpoint = useBreakpoint();
  const { hoverRef, isHovered } = useHover();
  const iconSize = breakpoint === Breakpoint.xs || small ? 38 : 48;
  const closeClasses = classNames(styles.close, { [styles["close--small"]]: small }, className);
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref: mergeRefs([ref, hoverRef]),
      "data-testid": testId,
      "data-analyticsid": AnalyticsId.Close,
      className: closeClasses,
      "aria-label": ariaLabel,
      onClick,
      type: "button",
      children: /* @__PURE__ */ jsx(Icon, { svgIcon: X, color, size: iconSize, isHovered })
    }
  );
});
export {
  Close as C
};
//# sourceMappingURL=Close.js.map
